export default "__VITE_ASSET__DSJCfmnq__"